"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
export default function Team() {
  const teamMembers = [{
    id: 1,
    name: "Sarah Mitchell",
    role: "Senior Accountant",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/sarah_mitchell_portrait.png",
    bio: "With over 15 years of experience in cloud accounting and financial management, Sarah leads our team with expertise and dedication to client success."
  }, {
    id: 2,
    name: "David Chen",
    role: "Cloud Solutions Specialist",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/david_chen_portrait.png",
    bio: "David specializes in implementing cutting-edge cloud accounting solutions, helping businesses transition seamlessly to modern financial systems."
  }, {
    id: 3,
    name: "Emma Thompson",
    role: "Tax Consultant",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/emma_thompson_portrait.png",
    bio: "Emma brings comprehensive tax knowledge and strategic planning expertise to ensure our clients maximize their financial efficiency and compliance."
  }];
  const socialLinks = [{
    memberId: 1,
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    linkedin: "https://linkedin.com",
    instagram: "https://www.instagram.com/sloanecollp/"
  }, {
    memberId: 2,
    facebook: "",
    twitter: "https://twitter.com",
    linkedin: "https://linkedin.com",
    instagram: "https://www.instagram.com/sloanecollp/"
  }, {
    memberId: 3,
    facebook: "https://facebook.com",
    twitter: "",
    linkedin: "https://linkedin.com",
    instagram: "https://www.instagram.com/sloanecollp/"
  }];
  return <section id="team" className="bg-dark-section text-dark-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] mb-4">
            Meet Our Team
          </h2>
          <p className="text-[16px] leading-[1.6] text-foreground max-w-2xl mx-auto">
            Experienced professionals dedicated to your financial success
          </p>
        </div>

        <div className="space-y-20">
          {teamMembers.map((member, i) => {
          const socials = socialLinks.find(s => s.memberId === member.id);
          return <div key={member.id} data-index={i} className="grid md:grid-cols-2 gap-12 items-center">
                <div className="order-1">
                  <SafeHydrate><Avatar className="w-full h-auto aspect-square max-w-md mx-auto rounded-full border-[1.5px] border-primary shadow-strong">
                    <AvatarImage src={member.image} alt={member.name} className="object-cover" />
                    <AvatarFallback className="text-[48px] font-bold bg-primary/10 text-foreground-primary">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                </div>

                <div className="order-2 space-y-6">
                  <div>
                    <h3 className="text-[28px] md:text-[36px] leading-[1.3] font-semibold tracking-[-0.2px] mb-2">
                      {member.name}
                    </h3>
                    <p className="text-primary text-[18px] font-medium mb-4">
                      {member.role}
                    </p>
                    <p className="text-[16px] leading-[1.6] text-foreground">
                      {member.bio}
                    </p>
                  </div>

                  {socials && <div className="flex gap-4 items-center">
                      {socials.facebook && <Link to={socials.facebook} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Facebook">
                          <Facebook className="w-5 h-5" />
                        </Link>}
                      {socials.twitter && <Link to={socials.twitter} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Twitter">
                          <Twitter className="w-5 h-5" />
                        </Link>}
                      {socials.linkedin && <Link to={socials.linkedin} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="LinkedIn">
                          <Linkedin className="w-5 h-5" />
                        </Link>}
                      {socials.instagram && <Link to={socials.instagram} newTab className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:-translate-y-1" aria-label="Instagram">
                          <Instagram className="w-5 h-5" />
                        </Link>}
                    </div>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}